module.exports = __webpack_public_path__ + "img/images-2-columns.dd682ac4.jpg";